<template>
  <div class="wrap">
    <myHead></myHead>
    <div class="wrap_body">
      <div class="center">
        <div class="ucenter_main">
          <ucMenu num="9"></ucMenu>
          <div class="right_con">
            <div class="rc_main" v-loading="pageLoading">
              <div class="page-header">
                <el-button icon="el-icon-arrow-left" size="small" @click="goBack">返回</el-button>
                <span class="title">盲盒铺货微信店铺编辑 - {{ shopInfo.shop_name }}</span>
              </div>

              <!-- 基础设置 -->
              <div class="section">
                <p class="section-title">基础设置</p>
                <el-form ref="baseForm" :model="formData" :rules="formRules" label-position="right" label-width="120px" size="small">
                  <el-form-item label="铺货限价：" prop="shop_limit_price">
                    <el-input-number v-model="formData.shop_limit_price" :controls="false" :min="0" :precision="2" class="w250"></el-input-number>
                    <span style="color: #999; margin-left: 10px;">限价指的是铺货时，自动过滤价格低于限价的商品</span>
                  </el-form-item>
                  <el-form-item label="上架策略：" prop="strategies_id">
                    <el-select v-model="formData.strategies_id" class="w250" placeholder="请选择">
                      <el-option v-for="item in strategiesList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="运费模板：" prop="freight_template_id">
                    <el-select v-model="formData.freight_template_id" class="w250" placeholder="请选择">
                      <el-option v-for="item in freightTemplate" :key="item.id" :label="item.template_name" :value="String(item.id)"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="运费险：">
                    <el-switch v-model="formData.freight_insurance" active-text="开启" inactive-text="关闭"></el-switch>
                  </el-form-item>
                  <el-form-item label="店铺商品来源：">
                    <el-input value="云商品库" class="w250" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="商品sku状态：">
                    <el-select v-model="formData.shop_product_repository_skus" multiple placeholder="请选择" style="width: 100%">
                      <el-option :value="1" label="上未替换"></el-option>
                      <el-option :value="2" label="上已替换"></el-option>
                      <el-option :value="3" label="上找不到"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="商品分组：">
                    <el-select v-model="formData.shop_product_repository_groups" multiple placeholder="不选择则不限制分组" style="width: 100%">
                      <el-option v-for="group in cloudGroupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="每日铺货数量：" prop="daily_num">
                    <el-input-number v-model="formData.daily_num" :controls="false" :max="maxAutoNum" :min="0" :precision="0" class="w250"></el-input-number>
                  </el-form-item>
                  <el-form-item label="售后地址：" prop="return_address_id">
                    <el-select v-model="formData.return_address_id" class="w250" placeholder="请选择售后地址">
                      <el-option v-for="item in returnAddressList" :key="item.address_id" :label="formatAddress(item)" :value="item.address_id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>

              <!-- 分类设置 -->
              <div class="section">
                <p class="section-title">分类设置</p>
                <p style="color: red; font-size: 12px; margin-bottom: 10px;">需要选择可以正常上货的分类，需要申请类目权限和缴纳对应的保证金，未缴纳保证金将铺货失败！</p>
                <el-form label-position="right" label-width="120px" size="small">
                  <el-form-item label="微信二级分类：">
                    <el-cascader
                      v-model="selectedCateIds"
                      :options="cateList"
                      :props="cateCascaderProps"
                      :popper-append-to-body="false"
                      clearable
                      collapse-tags
                      popper-class="wechat-blind-cate-cascader"
                      size="small"
                      style="width: 100%"
                      @change="changeCateCascader">
                    </el-cascader>
                    <p style="color: red;line-height: 20px">铺货时，微信预测前三个类目的二级类目与当前预设类目不一致，将会被拦截铺货。</p>
                  </el-form-item>
                  <el-form-item label="类目品牌：">
                    <div v-if="selectedCateList.length" :key="brandRandom">
                      <div v-for="item in selectedCateList" :key="item.category_id"
                           style="display: flex;align-items: center;margin: 8px 0;">
                        <div class="brand-cate-name">{{ item.path_names }}：</div>
                        <el-select v-model="item.brand" class="w250" placeholder="请选择品牌" value-key="brand_id">
                          <el-option v-for="brand in shopBrandList" :key="brand.brand_id" :label="brand.name_cn || brand.brand_name"
                                     :value="brand"></el-option>
                        </el-select>
                      </div>
                    </div>
                    <span v-else style="color: #999">请先选择分类</span>
                  </el-form-item>
                </el-form>
              </div>

              <!-- 底部按钮 -->
              <div class="footer-btns">
                <el-button @click="goBack">取消</el-button>
                <el-button type="primary" :loading="saveLoading" @click="saveSettings">保存设置</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <myFoot></myFoot>

  </div>
</template>

<script>
import { mapActions } from "vuex";
import myHead from "@/components/myHead/myhead.vue";
import myFoot from "@/components/myFoot/myfoot.vue";
import ucMenu from "@/components/ucenterMenu/ucmenu.vue";
import { cloudProductGroups } from "@/api/main/ucenter";

export default {
  name: 'wechatBlindBoxEdit',
  components: { ucMenu, myHead, myFoot },
  data() {
    return {
      shopId: '',
      shopInfo: {},
      pageLoading: false,
      saveLoading: false,
      cateLoading: false,
      // 基础表单
      formData: {
        shop_limit_price: 0,
        strategies_id: '',
        freight_template_id: '',
        freight_insurance: false,
        shop_product_source: 2,
        shop_product_repository_skus: [],
        shop_product_repository_groups: [],
        daily_num: 0,
        return_address_id: ''
      },
      cloudGroupList: [],
      returnAddressList: [],
      strategiesList: [],
      freightTemplate: [],
      maxAutoNum: 0,
      defaultNum: 0,
      // 表单验证规则
      formRules: {
        shop_limit_price: [{ required: true, message: '请输入铺货限价', trigger: 'blur' }],
        strategies_id: [{ required: true, message: '请选择上架策略', trigger: 'change' }],
        freight_template_id: [{ required: true, message: '请选择运费模板', trigger: 'change' }],
        daily_num: [{ required: true, message: '请输入每日铺货数量', trigger: 'blur' }],
        return_address_id: [{ required: true, message: '请选择售后地址', trigger: 'change' }]
      },
      // 分类相关
      cateList: [], // 微信二级分类树
      cateTableData: [], // 扁平化后的二级类目数据
      selectedCateIds: [], // 级联选中的二级类目路径
      selectedCateList: [], // 已选分类
      leafToSecondCateMap: {}, // 兼容历史叶子类目配置，回显时映射到二级类目
      cateCascaderProps: {
        multiple: true,
        value: 'category_id',
        label: 'category_name',
        children: 'sub_category',
        leaf: 'is_leaf',
        emitPath: true,
        checkStrictly: false
      },
      // 品牌相关
      shopBrandList: [], // 详情接口返回的品牌列表
      brandRandom: Math.random()
    }
  },
  created() {
    this.shopId = this.$route.query.shop_id
    if (!this.shopId) {
      this.$message.error('缺少店铺ID')
      this.goBack()
      return
    }
    this.initPage()
  },
  methods: {
    ...mapActions({
      getBlindBoxDetail: 'ucenter/getBlindBoxDetail',
      updateBlindBox: 'ucenter/updateBlindBox',
      fetchWechatCategoryList: 'ucenter/fetchWechatCategoryList'
    }),

    goBack() {
      this.$router.push('/uc_blindBox?menuId=130')
    },

    async initPage() {
      this.pageLoading = true
      try {
        // 云商品库来源需要分组筛选，加载失败不阻断基础配置。
        this.loadCloudGroupList()
        // 加载分类
        await this.loadCateList()
        // 加载店铺详情
        await this.loadShopDetail()
      } finally {
        this.pageLoading = false
      }
    },

    // 加载分类列表
    loadCateList() {
      return new Promise((resolve) => {
        this.cateLoading = true
        this.fetchWechatCategoryList({
          data: { shop_id: this.shopId },
          success: (res) => {
            this.cateLoading = false
            if (res.code == 200) {
              this.leafToSecondCateMap = this.buildLeafToSecondCateMap(res.data || [])
              this.cateList = this.buildSecondLevelCateTree(res.data || [])
              this.cateTableData = this.flattenCateTree(this.cateList)
            } else {
              this.$message.error(res.message)
            }
            resolve()
          }
        })
      })
    },

    // 微信盲盒只配置二级类目，原始类目树裁剪到二级供级联选择。
    buildSecondLevelCateTree(nodes) {
      return (nodes || []).map(item => {
        const children = (item.sub_category || []).map(second => {
          // Element Cascader 只要节点上存在 children 字段，就可能继续展开空列。
          const { sub_category, ...secondCate } = second
          return {
            ...secondCate,
            is_leaf: true
          }
        })
        return {
          ...item,
          sub_category: children
        }
      }).filter(item => item.sub_category && item.sub_category.length)
    },

    // 历史配置可能保存过叶子类目 ID，进入页面时统一映射成对应二级类目 ID。
    buildLeafToSecondCateMap(nodes) {
      const map = {}
      const walk = (node, secondId) => {
        if (!node) {
          return
        }
        map[String(node.category_id)] = secondId
        ;(node.sub_category || []).forEach(child => walk(child, secondId))
      }
      ;(nodes || []).forEach(root => {
        ;(root.sub_category || []).forEach(second => walk(second, second.category_id))
      })
      return map
    },

    getSecondCategoryId(categoryId) {
      return this.leafToSecondCateMap[String(categoryId)] || categoryId
    },

    // 加载云商品库分组列表
    loadCloudGroupList() {
      cloudProductGroups({ with_count: 0 }).then(res => {
        if (res.code === 200) {
          this.cloudGroupList = res.data || []
        }
      })
    },

    // 将分类树扁平化为表格数据
    flattenCateTree(nodes, level1 = '', level2 = '', level3 = '', level1_id = null, level2_id = null, level3_id = null) {
      const result = []
      const flatten = (nodes, l1, l2, l3, l1_id, l2_id, l3_id) => {
        nodes.forEach(node => {
          if (node.is_leaf) {
            // 根据路径层级决定放在哪一列
            const pathParts = node.path_names.split('>')
            const depth = pathParts.length
            let rowData = {
              row_key: `${node.category_id}`,
              category_id: node.category_id,
              path_names: node.path_names,
              cate_path: [l1_id, l2_id, l3_id, node.category_id].filter(id => id !== null && id !== undefined),
              level1_id: l1_id,
              level2_id: l2_id,
              level3_id: l3_id
            }
            if (depth === 2) {
              // 二级叶子节点
              rowData.level1_name = l1
              rowData.level2_name = node.category_name
              rowData.level3_name = '--'
              rowData.level4_name = '--'
              rowData.level2_id = node.category_id
            } else if (depth === 3) {
              // 三级叶子节点
              rowData.level1_name = l1
              rowData.level2_name = l2
              rowData.level3_name = node.category_name
              rowData.level4_name = '--'
              rowData.level3_id = node.category_id
            } else if (depth === 4) {
              // 四级叶子节点
              rowData.level1_name = l1
              rowData.level2_name = l2
              rowData.level3_name = l3
              rowData.level4_name = node.category_name
            } else {
              // 其他情况，默认放四级
              rowData.level1_name = l1
              rowData.level2_name = l2
              rowData.level3_name = l3
              rowData.level4_name = node.category_name
            }
            result.push(rowData)
          } else if (node.sub_category && node.sub_category.length) {
            const pathParts = node.path_names.split('>')
            const depth = pathParts.length
            if (depth === 1) {
              flatten(node.sub_category, node.category_name, '', '', node.category_id, null, null)
            } else if (depth === 2) {
              flatten(node.sub_category, l1, node.category_name, '', l1_id, node.category_id, null)
            } else if (depth === 3) {
              flatten(node.sub_category, l1, l2, node.category_name, l1_id, l2_id, node.category_id)
            }
          }
        })
      }
      flatten(nodes, level1, level2, level3, level1_id, level2_id, level3_id)
      return result
    },

    // 加载店铺详情
    loadShopDetail() {
      return new Promise((resolve) => {
        this.getBlindBoxDetail({
          data: { shop_id: this.shopId, shop_type: 7 },
          success: (res) => {
            if (res.code == 200) {
              const data = res.data
              // 店铺名和编辑数据都在data下
              this.shopInfo = { shop_name: data.shop_name || '' }
              this.strategiesList = data.strategies_list || []
              this.freightTemplate = (data.shop_freight_template_list || []).map(item => item.template)
              this.maxAutoNum = Number(data.max_auto_num) || 0
              this.shopBrandList = data.shop_brand_list || []
              this.returnAddressList = data.shop_return_address_list || []

              // 填充表单（数据直接在data下）
              this.formData.shop_limit_price = data.shop_limit_price || 0
              this.formData.strategies_id = data.strategies_id || ''
              this.formData.freight_template_id = data.shop_freight_template_id ? String(data.shop_freight_template_id) : ''
              this.formData.freight_insurance = data.freight_insurance == 1
              // 微信盲盒当前仅支持云商品库，历史系统商品配置进入编辑页时也固定为云商品库。
              this.formData.shop_product_source = 2
              this.formData.shop_product_repository_skus = Array.isArray(data.shop_product_repository_skus) ? data.shop_product_repository_skus : []
              const groups = Array.isArray(data.shop_product_repository_groups) ? data.shop_product_repository_groups : []
              this.formData.shop_product_repository_groups = groups.map(id => Number(id))
              this.formData.daily_num = data.daily_num || 0
              // 售后地址：优先使用已保存的，否则默认选择第一条
              this.formData.return_address_id = data.return_address_id || (this.returnAddressList.length ? this.returnAddressList[0].address_id : '')
              this.defaultNum = Number(data.default_num) || 0

              // 初始化已选分类
              if (data.categoryIds) {
                const ids = data.categoryIds.split(',').map(id => String(id).trim())
                const secondIds = [...new Set(ids.map(id => String(this.getSecondCategoryId(id))))]
                const brandKeyValues = data.brandKeyValues || {}
                this.selectedCateList = this.cateTableData
                  .filter(item => secondIds.includes(String(item.category_id)))
                  .map(item => {
                    const oldCategoryId = ids.find(id => String(this.getSecondCategoryId(id)) === String(item.category_id))
                    const brandData = brandKeyValues[item.category_id] || brandKeyValues[String(item.category_id)] || brandKeyValues[oldCategoryId] || brandKeyValues[String(oldCategoryId)] || brandKeyValues[item.level1_id] || brandKeyValues[String(item.level1_id)] || null
                    return {
                      ...item,
                      brand: brandData,
                      limit_num: this.defaultNum
                    }
                  })
                this.selectedCateIds = this.selectedCateList.map(item => item.cate_path)
              }
            } else {
              this.$message.error(res.message)
            }
            resolve()
          }
        })
      })
    },

    // 级联类目变更后同步已选类目，保留已有品牌和关键词设置。
    changeCateCascader(value) {
      const validPaths = value.filter(item => item.length >= 2)
      const secondIds = validPaths.map(item => String(item[item.length - 1]))
      this.selectedCateIds = validPaths
      const oldMap = {}
      this.selectedCateList.forEach(item => {
        oldMap[item.category_id] = item
      })
      this.selectedCateList = this.cateTableData
        .filter(item => secondIds.includes(String(item.category_id)))
        .map(item => {
          const old = oldMap[item.category_id] || {}
          return {
            ...item,
            brand: old.brand || null,
            limit_num: old.limit_num || this.defaultNum
          }
        })
      this.brandRandom = Math.random()
    },

    // 格式化地址显示
    formatAddress(item) {
      const parts = [item.province, item.city, item.area, item.detail].filter(p => p)
      const address = parts.join('')
      const contact = [item.name, item.phone_number].filter(p => p).join(' ')
      return contact ? `${address}（${contact}）` : address
    },

    // 保存设置
    saveSettings() {
      // 先验证基础表单
      this.$refs.baseForm.validate((valid) => {
        if (!valid) {
          this.$message.error('请填写完整基础信息')
          return
        }
        this.doSaveSettings()
      })
    },

    // 执行保存
    doSaveSettings() {
      try {
        if (!this.formData.shop_product_repository_skus.length) {
          throw '请选择云商品库铺货商品sku状态'
        }
        // 获取选中分类ID
        const categoryIds = this.selectedCateList.map(item => item.category_id)
        // 获取品牌设置（按微信二级类目保存）
        const brandKeyValues = {}
        this.selectedCateList.forEach(item => {
          if (item.brand && item.brand.brand_id) {
            brandKeyValues[item.category_id] = {
              brand_id: item.brand.brand_id,
              brand_name: item.brand.name_cn || item.brand.brand_name
            }
          }
        })
        const freightItem = this.freightTemplate.find(i => i.id == this.formData.freight_template_id)
        const params = {
          shop_id: this.shopId,
          shop_type: 7,
          shop_limit_price: this.formData.shop_limit_price,
          daily_num: this.formData.daily_num,
          strategies_id: this.formData.strategies_id,
          freight_template_id: this.formData.freight_template_id,
          freight_template_name: freightItem ? freightItem.template_name : '',
          freight_insurance: this.formData.freight_insurance ? 1 : 0,
          return_address_id: this.formData.return_address_id,
          shop_product_source: 2,
          shop_product_repository_skus: this.formData.shop_product_repository_skus,
          shop_product_repository_groups: this.formData.shop_product_repository_groups,
          categoryIds: categoryIds.join(','),
          brandKeyValues: brandKeyValues
        }

        this.saveLoading = true
        this.updateBlindBox({
          data: params,
          success: (res) => {
            this.saveLoading = false
            if (res.code == 200) {
              this.$message.success('保存成功')
              this.goBack()
            } else {
              this.$message.error(res.message)
            }
          }
        })
      } catch (e) {
        this.$message.error(e)
        this.saveLoading = false
      }
    }
  }
}
</script>

<style scoped>
/* 布局样式 */

.center {
  display: flex;
  flex: 1;
}
.ucenter_main {
  min-height: 500px;
}

.rc_main {
  padding: 36px 40px 46px;
}

/* 页面内容样式 */
.page-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}
.page-header .title {
  font-size: 16px;
  font-weight: bold;
  margin-left: 15px;
}
.section {
  margin-bottom: 30px;
}
.section-title {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 15px;
  padding-left: 10px;
  border-left: 3px solid #409EFF;
}
.footer-btns {
  text-align: center;
  padding: 20px 0;
  border-top: 1px solid #eee;
  margin-top: 20px;
}
.w250 {
  width: 250px;
}
.brand-cate-name {
  flex: 1;
  margin-right: 10px;
  line-height: 20px;
}

/* 一级类目只用于展开，不能直接勾选保存。 */
:deep(.wechat-blind-cate-cascader .el-cascader-menu:first-child .el-checkbox) {
  display: none;
}

</style>
